/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["crupdate-user-modal{display:block}crupdate-user-modal user-access-manager{margin-top:25px}"];
export { styles as styles };
